import React, { useEffect, useRef, useState } from "react";
import hljs from "highlight.js";
import ReactQuill from "react-quill-new";
import { Link } from "react-router-dom";
import { createEmailTemplate, createPackageApi, getPackageSizeApi } from "../../apiHelper/authService";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { clearSelectedPackage } from "../../redux/authModalSlice";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
const AddPackage = () => {
    const navigate = useNavigate()
    const [imagePreview, setImagePreview] = useState(null);
    const { selectedPackage } = useSelector((state) => state.authModal);
    console.log("Seleted Package ::",selectedPackage);
    
    const { user } = useSelector((state) => state.authModal);
    const fromCountry = user?.from;
    const toCountry = user?.to;

    // const handleFileChange = (e) => {
    //     if (e.target.files && e.target.files.length > 0) {
    //         const src = URL.createObjectURL(e.target.files[0]);
    //         setImagePreview(src);
    //     }
    // };

    // const handleRemoveImage = () => {
    //     setImagePreview(null);
    // };
    const quillRef = useRef(null);
    const [value, setValue] = useState(``);
    // eslint-disable-next-line no-unused-vars
    const [isHighlightReady, setIsHighlightReady] = useState(false);
    const dispatch = useDispatch()

    useEffect(() => {
        // Load highlight.js configuration and signal when ready
        hljs?.configure({
            languages: [
                "javascript",
                "ruby",
                "python",
                "java",
                "csharp",
                "cpp",
                "go",
                "php",
                "swift",
            ],
        });
    }, []);

    // eslint-disable-next-line no-unused-vars
    const handleSave = () => {
        const editorContent = quillRef.current.getEditor().root.innerHTML;
        console.log("Editor content:", editorContent);
    };

    // Quill editor modules with syntax highlighting (only load if highlight.js is ready)
    const modules = isHighlightReady
        ? {
            syntax: {
                highlight: (text) => hljs?.highlightAuto(text).value, // Enable highlight.js in Quill
            },
            toolbar: {
                container: "#toolbar-container", // Custom toolbar container
            },
        }
        : {
            toolbar: {
                container: "#toolbar-container", // Custom toolbar container
            },
        };

    const formats = [
        "font",
        "size",
        "bold",
        "italic",
        "underline",
        "strike",
        "color",
        "background",
        "script",
        "header",
        "blockquote",
        "code-block",
        "list",
        "indent",
        "direction",
        "align",
        "link",
        "image",
        "video",
        "formula",
    ];


    const [sizeName, setSizeName] = useState('');
    const [sizeLength, setSizeLength] = useState('');
    const [sizeWidth, setSizeWidth] = useState('');
    const [sizeHeight, setSizeHeight] = useState('');
    const [sizeWeight, setSizeWeight] = useState('');
    const [discount, setDiscount] = useState('');
    const [loading, setLoading] = useState(false)
    const [shipmentShip, setShipmentShip] = useState('');
    const [shipmentAir, setShipmentAir] = useState('');
    const [ecomShip, setEcomShip] = useState('');
    const [ecomAir, setEcomAir] = useState('');
    const [selectedUnit, setSelectedUnit] = useState("Inch");

    const [isAddNote, setIsAddNote] = useState(false)
    const [isInquiryRequired, setIsInquiryRequired] = useState(false)
    const [noteTitle, setNoteTitle] = useState("")
    const [noteDesc, setNoteDesc] = useState("")
    const [packageCategory,setPackageCategory] = useState("B2B")




    const [subject, setSubject] = useState('');






    // const [subject, setSubject] = useState('');
    const [message, setMessage] = useState('');

    const [packageId, setPackageId] = useState(''); // can be generated or user-input
    const [mailImage, setMailImage] = useState(null);
    //   const [imagePreview, setImagePreview] = useState(null);

    //   const quillRef = useRef();
    const [imageName, setImageName] = useState('');

    const [ShipmentCharges, setShipmentCharges] = useState([]);



    const getPackageSizes = async () => {
        // setLoading(true);



        // const toastId = toast.loading("Fetching Email Templates...");

        try {
            const data = await getPackageSizeApi();
            console.log(data)
            setShipmentCharges(data?.shipmentCharges || []);

            // setCategories(data);
            // setPackageData(data)
            // toast.success("Email Templates fetched successfully!", { id: toastId });
        } catch (err) {
            console.error("Fetch Error:", err);

            toast.error(
                err?.message || "Something went wrong.",
       
            );
        } finally {
            // setLoading(false);
        }
    };

    // console.log(ShipmentCharges)


    useEffect(() => {

        getPackageSizes()


    }, [])

    const handleFileChange = (event) => {
        const file = event.target.files[0];
        if (file && file.type.startsWith('image/')) {
            setMailImage(file);

            setImagePreview(URL.createObjectURL(file));
            setImageName(file.name);
        } else {
            alert('Please upload a valid image file');
        }
    };

    const handleRemoveImage = () => {
        setMailImage(null);

        setImagePreview(null);
        setImageName('');
    };

    const handleSubmit = async (e) => {
        e.preventDefault();


        // if (!value || value === '<p><br></p>') {
        //     toast.error("Message is required");
        //     return;
        // }

        if (!imagePreview) {
            toast.error("Image is required");
            return;
        }
        setLoading(true)




        const formData = new FormData();
        formData.append('size_name', sizeName);
        formData.append('size_length', sizeLength);
        formData.append('size_width', sizeWidth);
        formData.append('size_height', sizeHeight);
        formData.append('size_weight', sizeWeight);
        formData.append('discount', discount);
        formData.append('inch', selectedUnit === "Inch" ? true : false);
        formData.append('isInfoVisible', isAddNote);
        formData.append("packageCategory", packageCategory);
        formData.append('isInquiryRequired',isInquiryRequired)
        if (isAddNote) {
            formData.append('title', noteTitle);
            formData.append('description', noteDesc);
        }





        formData.append('from', fromCountry);
        formData.append('to', toCountry);
        formData.append('id', packageId);


        if (mailImage) {
            formData.append('icon_url', mailImage);
        }

        try {
            const res = await createPackageApi(formData);
            console.log('Success:', res);
            navigate("/package-sizes")


        } catch (err) {

            console.error('Error:', err);
        }

        finally {
            setLoading(false)
        }


    };

    //Insert var|

    // const insertVariable = (e) => {
    //     const variable = e.target.value;

    //     if (!variable || !quillRef.current) return;

    //     const editor = quillRef.current.getEditor();
    //     const cursorPosition = editor.getSelection()?.index || 0;
    //     editor.insertText(cursorPosition, `{${variable}}`);
    //     editor.setSelection(cursorPosition + variable.length + 2);
    //     e.target.value = '';
    // };

    console.log("Package", selectedPackage)


    useEffect(() => {
        if (selectedPackage) {
          console.log("UPDATE SELECTED PRODUCT ::",selectedPackage);
          
            setSizeName(selectedPackage?.size_name || '')
            setSizeLength(selectedPackage?.size_length || '')
            setSizeWidth(selectedPackage?.size_width || '')
            setSizeHeight(selectedPackage?.size_height || '')
            setSizeWeight(selectedPackage?.size_weight || '')
            setSizeWeight(selectedPackage?.size_weight || '')
            setDiscount(selectedPackage?.discount || '')
            setSelectedUnit(selectedPackage?.inch ? "Inch" : "Feet" || '')
            setPackageId(selectedPackage?.id || '')
            setIsAddNote(selectedPackage?.isInfoVisible || false)
            setPackageCategory(selectedPackage.packageCategory || "");
            setIsInquiryRequired(selectedPackage.isInquiryRequired || false)
        //  if(isAddNote) {
                setNoteTitle(selectedPackage?.title)
                setNoteDesc(selectedPackage?.description)
            // }
            


            // setEmailId(selectedEmailTemplate?.id || '')




            if (selectedPackage?.icon_url) {
                setImagePreview(selectedPackage.icon_url);
                const imageName = selectedPackage.icon_url
                setImageName(imageName);
                setMailImage(selectedPackage?.icon_url)
            } else {
                setImagePreview(null);
                setImageName('');
                setMailImage('')
            }



        }

        return () => {

            dispatch(clearSelectedPackage());
        };
    }, [selectedPackage, dispatch]);

    // console.log(mailImage)
    function getTotalFieldValue(info) {
        const local_delivery_charge = info?.local_delivery_charge
            ? info?.local_delivery_charge
            : 0;
        const international_courier_charge = info?.international_courier_charge
            ? info?.international_courier_charge
            : 0;
        const human_resource_charge = info?.human_resource_charge
            ? info?.human_resource_charge
            : 0;
        const taxes = info?.taxes ? info?.taxes : 0;
        let grandTotal = local_delivery_charge + international_courier_charge;
        if (info?.Order_charges_type === "ECOM") {
            grandTotal += human_resource_charge;
        }
        const taxAmount = (grandTotal * taxes) / 100;
        return taxAmount + grandTotal;
    }


    function calculateShipmentAmountTotal(shipType, orderType, value = 0) {
        const charges = ShipmentCharges.find(
            (el) =>
                el.shipping_charges_type === shipType &&
                el.Order_charges_type === orderType
        );
        const amountWithTax = getTotalFieldValue({
            ...charges,
            Order_charges_type: orderType,
        });
        let grandTotal = amountWithTax * value;
        if (discount) {
            const discountAmount = (grandTotal * discount) / 100;
            grandTotal = grandTotal - discountAmount;
        }
        return grandTotal.toFixed(2);
    }



    const handleNumericInput = (e, setter) => {
        const value = e.target.value;

        if (/^\d*\.?\d*$/.test(value)) {
            setter(value);
        }
    };


    return (
      <div className="row gy-4">
        <div className="col-lg-12">
          <div className="card mt-24">
            <div className="card-header border-bottom">
              <h6 className="text-xl mb-0">Add New Package Sizes</h6>
            </div>
            <div className="card-body p-24">
              <form
                onSubmit={handleSubmit}
                className="d-flex flex-column gap-20"
              >
                <div className="row">
                  <div className="col-12 col-md-4 mb-3">
                    <label
                      className="form-label fw-bold text-neutral-900"
                      htmlFor="sizeName"
                    >
                      Size Name:
                    </label>
                    <input
                      type="text"
                      required
                      className="form-control border border-neutral-200 radius-8"
                      id="sizeName"
                      placeholder="Enter Size Name"
                      value={sizeName}
                      onChange={(e) => setSizeName(e.target.value)}
                    />
                  </div>

                  <div className="col-12 col-md-4 mb-3">
                    <label
                      className="form-label fw-bold text-neutral-900"
                      htmlFor="sizeLength"
                    >
                      Size Length:
                    </label>
                    <input
                      type="text"
                      required
                      className="form-control border border-neutral-200 radius-8"
                      id="sizeLength"
                      placeholder="Enter Size Length"
                      value={sizeLength}
                      onChange={(e) => handleNumericInput(e, setSizeLength)}
                    />
                  </div>

                  <div className="col-12 col-md-4 mb-3">
                    <label
                      className="form-label fw-bold text-neutral-900"
                      htmlFor="sizeWidth"
                    >
                      Size Width:
                    </label>
                    <input
                      type="text"
                      required
                      className="form-control border border-neutral-200 radius-8"
                      id="sizeWidth"
                      placeholder="Enter Size Width"
                      value={sizeWidth}
                      // onChange={(e) => setSizeWidth(e.target.value)}

                      onChange={(e) => handleNumericInput(e, setSizeWidth)}
                    />
                  </div>
                </div>

                <div className="row">
                  <div className="col-12 col-md-4 mb-3">
                    <label
                      className="form-label fw-bold text-neutral-900"
                      htmlFor="sizeHeight"
                    >
                      Size Height:
                    </label>
                    <input
                      type="text"
                      required
                      className="form-control border border-neutral-200 radius-8"
                      id="sizeHeight"
                      placeholder="Enter Size Height"
                      value={sizeHeight}
                      // onChange={(e) => setSizeHeight(e.target.value)}
                      onChange={(e) => handleNumericInput(e, setSizeHeight)}
                    />
                  </div>

                  <div className="col-12 col-md-4 mb-3">
                    <label
                      className="form-label fw-bold text-neutral-900"
                      htmlFor="sizeWeight"
                    >
                      Size Weight (KG):
                    </label>
                    <input
                      type="text"
                      required
                      className="form-control border border-neutral-200 radius-8"
                      id="sizeWeight"
                      placeholder="Enter Size Weight"
                      value={sizeWeight}
                      // onChange={(e) => setSizeWeight(e.target.value)}
                      onChange={(e) => handleNumericInput(e, setSizeWeight)}
                    />
                  </div>

                  <div className="col-12 col-md-4 mb-3">
                    <label
                      className="form-label fw-bold text-neutral-900"
                      htmlFor="discount"
                    >
                      Discount (%):
                    </label>
                    <input
                      type="text"
                      required
                      className="form-control border border-neutral-200 radius-8"
                      id="discount"
                      placeholder="Enter Discount"
                      value={discount}
                      // onChange={(e) => setDiscount(e.target.value)}
                      onChange={(e) => handleNumericInput(e, setDiscount)}
                    />
                  </div>
                </div>

                <div className="row">
                  <div className="col-12 col-md-6 mb-3">
                    <label
                      className="form-label fw-bold text-neutral-900"
                      htmlFor="shipmentShip"
                    >
                      Shipment Ship:
                    </label>
                    <input
                      disabled
                      type="text"
                      required
                      className="form-control border border-neutral-200 radius-8"
                      id="shipmentShip"
                      // placeholder='Enter Size Name'
                      placeholder="Auto-calculated"
                      value={calculateShipmentAmountTotal(
                        "SHIP",
                        "SHIPMENT",
                        sizeWeight
                      )}
                      // onChange={(e) => setShipmentShip(e.target.value)}
                      readOnly
                    />
                  </div>

                  <div className="col-12 col-md-6 mb-3">
                    <label
                      className="form-label fw-bold text-neutral-900"
                      htmlFor="shipmentAir"
                    >
                      Shipment Air:
                    </label>
                    <input
                      disabled
                      type="text"
                      required
                      className="form-control border border-neutral-200 radius-8"
                      id="shipmentAir"
                      // placeholder='Enter Size Length'
                      placeholder="Auto-calculated"
                      value={calculateShipmentAmountTotal(
                        "AIR",
                        "SHIPMENT",
                        sizeWeight
                      )}
                      readOnly

                      // onChange={(e) => setShipmentAir(e.target.value)}
                    />
                  </div>

                  {/* <div className="col-12 col-md-3 mb-3">
                                    <label className='form-label fw-bold text-neutral-900' htmlFor='ecomShip'>
                                        Ecommerce Ship:
                                    </label>
                                    <input
                                        disabled

                                        type='text'
                                        required
                                        className='form-control border border-neutral-200 radius-8'
                                        id='ecomShip'
                                        placeholder='Auto-calculated'
                                        value={calculateShipmentAmountTotal("SHIP", "ECOM", sizeWeight)}
                                        readOnly

                                    />
                                </div>

                                <div className="col-12 col-md-3 mb-3">
                                    <label className='form-label fw-bold text-neutral-900' htmlFor='ecomAir'>
                                        Ecommerce Air:
                                    </label>
                                    <input
                                        disabled

                                        type='text'
                                        required
                                        className='form-control border border-neutral-200 radius-8'
                                        id='ecomAir'

                                        placeholder='Auto-calculated'
                                        value={calculateShipmentAmountTotal("AIR", "ECOM", sizeWeight)}
                                        readOnly
                                    />
                                </div> */}
                </div>

                {/* <div className="row">
                                <div className="col-12 col-md-6 mb-3">
                                    <label className='form-label fw-bold text-neutral-900' htmlFor='sizeWeight'>
                                        Size Weight (KG):
                                    </label>
                                    <input
                                        type='text'
                                        required
                                        className='form-control border border-neutral-200 radius-8'
                                        id='sizeName'
                                        placeholder='Enter Size Weight'
                                        value={sizeWeight}
                                        onChange={(e) => setSizeWeight(e.target.value)}
                                    />
                                </div>

                                <div className="col-12 col-md-6 mb-3">
                                    <label className='form-label fw-bold text-neutral-900' htmlFor='discount'>
                                        Discount (%):
                                    </label>
                                    <input
                                        type='text'
                                        required
                                        className='form-control border border-neutral-200 radius-8'
                                        id='discount'
                                        placeholder='Enter Discount'
                                        value={discount}
                                        onChange={(e) => setDiscount(e.target.value)}
                                    />
                                </div>
                            </div> */}

                {/* <div>
                                <label
                                    className='form-label fw-bold text-neutral-900'
                                    htmlFor='subject'
                                >
                                    Subject:{" "}
                                </label>
                                <input

                                    type='text'
                                    required
                                    className='form-control border border-neutral-200 radius-8'
                                    id='subject'
                                    placeholder='Enter Subject'
                                    value={subject}
                                    onChange={(e) => setSubject(e.target.value)}
                                />
                            </div> */}

                <div className="row">
                  <div className="col-6 col-md-2">
                    <label
                      className="form-label fw-bold text-neutral-900"
                      htmlFor="sizeName"
                    >
                      In Inch or Feet
                    </label>

                    <div className="dropdown">
                      <button
                        className="btn btn-primary-600 bg-primary-50 border-primary-50 text-primary-600 hover-text-primary not-active px-18 py-11 dropdown-toggle toggle-icon"
                        type="button"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                      >
                        {selectedUnit}
                      </button>

                      <ul className="dropdown-menu">
                        <li>
                          <button
                            type="button"
                            className="dropdown-item px-16 py-8 rounded text-secondary-light bg-hover-neutral-200 text-hover-neutral-900"
                            onClick={() => setSelectedUnit("Inch")}
                          >
                            Inch
                          </button>
                        </li>
                        <li>
                          <button
                            type="button"
                            className="dropdown-item px-16 py-8 rounded text-secondary-light bg-hover-neutral-200 text-hover-neutral-900"
                            onClick={() => setSelectedUnit("Feet")}
                          >
                            Feet
                          </button>
                        </li>
                      </ul>
                    </div>
                  </div>

                  <div className="col-12 col-md-4 mb-3">
                    <label
                      className="form-label fw-bold text-neutral-900"
                      htmlFor="shipDuration"
                    >
                      Customer Category :
                    </label>

                    <select
                      className="form-control border border-neutral-200 radius-8"
                      name="customerCategory"
                      value={packageCategory}
                      onChange={(e) => setPackageCategory(e.target.value)}
                      required
                    >
                      <option value="">-- Select Customer Type --</option>
                      <option value="B2B">Business (B2B)</option>
                      <option value="B2C">Individual (B2C)</option>
                    </select>
                    {/* {formErrors.customerCategory && ( */}
                    <small className="text-danger">
                      {/* {formErrors.customerCategory} */}
                    </small>
                    {/* )} */}
                  </div>

                  <div className="col-12 col-md-3 mb-3">
                    <label className="form-label fw-bold text-neutral-900">
                      Add Note
                    </label>
                    <select
                      name="isAddNote"
                      className="form-control"
                      value={isAddNote ? "Yes" : "No"}
                      onChange={(e) => setIsAddNote(e.target.value === "Yes")}
                    >
                      <option value="No">No</option>
                      <option value="Yes">Yes</option>
                    </select>
                  </div>

                  <div className="col-12 col-md-3 mb-3">
                    <label className="form-label fw-bold text-neutral-900">
                    Requires Review ?
                    </label>
                    {console.log("IS INQUIRY REQUIRED ::",isInquiryRequired)}
                    <select
                      name="isInquiryRequired"
                      className="form-control"
                      value={isInquiryRequired ? "Yes" : "No"}
                      onChange={(e) => setIsInquiryRequired(e.target.value === "Yes")}
                    >
                      <option value="No">No</option>
                      <option value="Yes">Yes</option>
                    </select>
                  </div>
                  
                </div>

                {isAddNote && (
                  <>
                    <div className="col-12 col-md-6 mb-3">
                      <label className="form-label fw-bold text-neutral-900">
                        Note Title
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Enter note title"
                        value={noteTitle}
                        required
                        onChange={(e) => setNoteTitle(e.target.value)}
                      />
                    </div>

                    <div className="col-12 col-md-6 mb-3">
                      <label className="form-label fw-bold text-neutral-900">
                        Note Description
                      </label>
                      <textarea
                        className="form-control"
                        placeholder="Enter note description"
                        rows={4}
                        value={noteDesc}
                        required
                        onChange={(e) => setNoteDesc(e.target.value)}
                      />
                    </div>
                  </>
                )}

                <div className="row">
                  <div className="col-12 col-md-6">
                    <label className="form-label fw-bold text-neutral-900">
                      Package Box Icon
                    </label>
                    <div className="upload-image-wrapper">
                      {imagePreview ? (
                        <div className="uploaded-msg-wrapper h-160-px w-100 border input-form-light radius-8 overflow-hidden border-dashed bg-success-50 d-flex justify-content-between align-items-center px-3">
                          <div>
                            <p className="mb-1 fw-semibold text-success-700">
                              Image uploaded successfully
                            </p>
                            <p className="mb-0 text-sm text-neutral-700">
                              {imageName}
                            </p>
                          </div>
                          <button
                            type="button"
                            className="btn btn-sm btn-danger ms-3"
                            onClick={handleRemoveImage}
                          >
                            Remove
                          </button>
                        </div>
                      ) : (
                        <label
                          className="upload-file h-160-px w-100 border input-form-light radius-8 overflow-hidden border-dashed bg-neutral-50 bg-hover-neutral-200 d-flex align-items-center flex-column justify-content-center gap-1 cursor-pointer"
                          htmlFor="upload-file"
                        >
                          <iconify-icon
                            icon="solar:camera-outline"
                            className="text-xl text-secondary-light"
                          ></iconify-icon>
                          <span className="fw-semibold text-secondary-light">
                            Upload
                          </span>
                          <input
                            id="upload-file"
                            type="file"
                            hidden
                            accept="image/*"
                            onChange={handleFileChange}
                          />
                        </label>
                      )}
                    </div>
                  </div>
                </div>

                <button
                  type="submit"
                  className="btn btn-primary-600 radius-8 col-md-2"
                  disabled={loading && true}
                >
                  {loading ? "Submitting..." : "Submit"}
                </button>
              </form>
            </div>
          </div>
        </div>
        {/* Sidebar Start */}
      </div>
    );
};

export default AddPackage;
